<template>
  <header class="menu">
    <div class="logo">
      <img class="logoImg" :src="icon" alt="">
      <h2>{{titleText}}</h2>
    </div>
  </header>
</template>

<script>
import defaultLogo from '@/assets/image/logo.png'

export default {
  name: 'Header',
  data() {
    return {
      icon: defaultLogo,
      titleText: ''
    }
  },
  created() {
    // pageConfig 缺失时回退到默认 logo，避免图标为空
    const userInfo = this.$store.state.userInfo || {}
    const pageConfig = userInfo.pageConfig || {}
    this.icon = pageConfig.icon || defaultLogo
    this.titleText = pageConfig.titleText || '个人中心'
  },
  methods: {},
  computed: {},
  watch: {}
}
</script>

<style lang="scss" scoped>
.menu {
  width: 100%;
  height: 58px;
  background: #ffffff;
  padding-left: 24px;
}
.logo {
  display: flex;
  align-items: center;
  .logoImg {
    width: 76px;
    height: 32px;
  }
  h2 {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    line-height: 58px;
    padding-left: 24px;
    margin-left: 24px;
    position: relative;
    &::before {
      content: '';
      width: 1px;
      height: 16px;
      background: #e9e9e9;
      position: absolute;
      top: 21px;
      left: 0;
    }
  }
}
</style>